import { NumericTextBox } from "@progress/kendo-react-inputs";

export default function BudgetSettings({ draft, onChange, t = {} }) {
  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.plan || "Plan"}</p>
          <h3>{t.budgetAndIncome || "Budget and income"}</h3>
        </div>
      </div>
      <div className="settings-two-column">
        <div className="field">
          <label>{t.monthlyIncome || "Monthly income"}</label>
          <NumericTextBox
            value={draft.monthlyIncome}
            min={0}
            format="n2"
            onChange={(event) => onChange({ monthlyIncome: event.value || 0 })}
          />
        </div>
        <div className="field">
          <label>{t.monthlyBudget || "Monthly budget"}</label>
          <NumericTextBox
            value={draft.monthlyBudget}
            min={0}
            format="n2"
            onChange={(event) => onChange({ monthlyBudget: event.value || 0 })}
          />
        </div>
      </div>
    </div>
  );
}
